import { gql } from "@apollo/client";

export const DELETE_USER_RESTAURANT = gql`
    mutation gqlDeleteUserRestaurant($nID: Int!, $nIDRestaurant: Int!) {
        code: gqlDeleteUserRestaurant(nID: $nID, nIDRestaurant: $nIDRestaurant)
    }
`;

export const INSERT_USER_RESTAURANT = gql`
    mutation gqlInsertUserRestaurant($user: UserRestaurantInput!) {
        code: gqlInsertUserRestaurant(user: $user)
    }
`;

export const UPDATE_USER_RESTAURANT = gql`
    mutation gqlUpdateUserRestaurant($nID: Int!, $user: UserRestaurantInput!) {
        code: gqlUpdateUserRestaurant(nID: $nID, user: $user)
    }
`;